<script>
    import { onMount, beforeUpdate, afterUpdate, createEventDispatcher, onDestroy } from 'svelte';
    import { auth, db, user, functions, hashtag, next_session } from './stores.js';
    import SignIn from './components/SignIn.svelte';
    export let id;
    let hacoDetails = {};
    let userSocial;
    let hacoActive = true;
    let timer;
    let haco;
    const dispatch = createEventDispatcher();
    let creds; // jwt, token, hacoToken, apiKey
    let status = "";

    let conversation;
    let session;

    let firstLoad = true;

    let setupCompleted = false;
    let gotCreds = false;

    let requestSent = false;

    let members;

    let hacoURL = `https://cypher.untilit.works/haco/${id}`;

    let copy = "copy";
    

    $: isAdmin = $user && $user.uid === hacoDetails.uid;
    $: memberStatus = $user && hacoDetails.members && hacoDetails.members[$user.uid] && hacoDetails.members[$user.uid].status
    $: gotEverything = haco && gotCreds && firstLoad && setupCompleted;
    // $: membersApproved = [];
    // $: membersPending = [];
    $: membersApproved = members ? members.filter( member => member.status === "approved") : [];
    $: membersPending = members ? members.filter( member => member.status === "pending") : [];

    onMount(async () => {
        if ($user){
            loadInfo($user.uid);
        }
        // $db.collection("hacos").doc(id)
        //     .onSnapshot((doc) => {
        //         if (doc.data()){
        //             console.log("hacoDetails: ", doc.data());
        //             hacoDetails = doc.data();
        //             console.log("$user.uid: ", $user.uid);
        //             if ( firstLoad && hacoDetails.members[$user.uid] && (hacoDetails.members[$user.uid].status === "approved" || hacoDetails.members[$user.uid].status === "admin")){
        //                 console.log("get creds!");
        //                 getCreds();
        //             }
        //         } else {
        //             hacoActive = false;
        //         };
        //     },(error) => {
        //         console.error("error: ", error);
        //     });


        // if ((memberStatus === "approved" || hacoDetails === "admin") && firstLoad){
        //     console.log('get creds!');
        //     firstLoad = false;
        // }

        // console.log("NexmoClient: ",NexmoClient);
        // console.log("OT: ",OT);

        // haco.title = hacoDetails.title;
    });

    onDestroy(() => {
        console.log('onDestroy');
        if (session) {
            session.disconnect();
        }
    });

	$auth.onAuthStateChanged(function(userAuthState) {
        console.log("onAuthStateChanged");
		if(userAuthState){
            console.log('userAuthState');
            firstLoad = true;
            gotCreds = false;
            setupCompleted = false;
            loadInfo(userAuthState.uid);
		} else {
            if (session) {
                console.log('disconnect session');
                session.disconnect();
            }
			// console.log('onAuthStateChanged no user');
			// $user = null;
		};
	});

    function loadInfo(uid) {
        // get logged in social account
        $db.collection("users").doc(uid).get().then((doc) => {
            if (doc.exists) {
                console.log("User data: ", doc.data());
                userSocial = {...doc.data()};
                console.log("userSocial: ", userSocial);



                $db.collection("hacos").doc(id)
                    .onSnapshot((doc) => {
                        if (doc.data()){
                            console.log("hacoDetails: ", doc.data());
                            hacoDetails = doc.data();
                            console.log("members: ", Object.entries(hacoDetails.members).map(entry => ({id:entry[0], ...entry[1]})));
                            members = Object.entries(hacoDetails.members).map(entry => ({id:entry[0], ...entry[1]}));
                            console.log("$user.uid: ", $user.uid);
                            if ( firstLoad && hacoDetails.members[$user.uid] && (hacoDetails.members[$user.uid].status === "approved" || hacoDetails.members[$user.uid].status === "admin")){
                                console.log("get creds!");
                                getCreds();
                            }
                        } else {
                            hacoActive = false;
                        };
                    },(error) => {
                        console.error("error: ", error);
                    });










            } else {
                console.error("No such document");
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
    };

    afterUpdate(() => {
		console.log("after update");
        if (timer) {
            timer.restart($next_session);
        }
        // console.log("haco: ", haco);
        // console.log("gotCreds: ", gotCreds);
        // console.log("firstLoad: ", firstLoad);
        // console.log("setupCompleted: ", setupCompleted);
        // console.log("gotEverything: ", gotEverything);
        if (haco && gotCreds && firstLoad && setupCompleted) {
            console.log('updating HACO! AFTER');
            console.log("conversation: ",conversation);
            haco.title = hacoDetails.title;
            haco.conversation = conversation;
            haco.opentok = OT;
            haco.token = creds.token;
            haco.session = session;

            // conversation.getMyMember().then((member) => {
            //     console.log('get my member',member);
            // }).catch((error) => {
            //     console.error("error getting my member", error);
            // });

            if (memberStatus === "admin"){
                haco.isCreator = true;
            } else {
                haco.isCreator = false;
            }

            firstLoad = false;
        }
	});


    // beforeUpdate(() => {
	// 	console.log("before update");
    //     // if (timer) {
    //     //     timer.restart($next_session);
    //     // }
    //     console.log("haco: ", haco);
    //     console.log("gotCreds: ", gotCreds);
    //     console.log("firstLoad: ", firstLoad);
    //     console.log("setupCompleted: ", setupCompleted);
    //     console.log("gotEverything: ", gotEverything);
    //     if (haco && gotCreds && firstLoad && setupCompleted) {
    //         console.log('updating HACO! BEFORE');
    //         console.log("conversation: ",conversation);
    //         haco.title = hacoDetails.title;
    //         haco.conversation = conversation;
    //         haco.opentok = OT;
    //         haco.token = creds.token;
    //         haco.session = session;

    //         if (memberStatus === "admin"){
    //             haco.isCreator = true;
    //         } else {
    //             haco.isCreator = false;
    //         }

    //         // firstLoad = false;
    //     }
	// });


    function sendRequest(){
        status = "Sending request..."
        const joinHACO = $functions.httpsCallable('joinHACO');
        const {conversationId, sessionId, uid} = hacoDetails;
        joinHACO({userSocial, conversationId, sessionId, hacoId: id})
            .then((results) => {
                console.log("sendRequest results: ", results);
                if (results.data.code === 200){
                    status = "Request sent successfully";
                } else {
                    status = `Got an error: ${results.data.details}`;
                    requestSent = false;
                }
                // creds = results;
                // setupHACO();
            }).catch((error)=>{
                console.log("joinHACO error: ", error);
                status = `Error trying to join HACO: ${error}`;
                requestSent = false;
            });
    };

    function getCreds(){
        const getCreds = $functions.httpsCallable('getCreds')
        const {conversationId, sessionId, uid} = hacoDetails;
        getCreds({userSocial, conversationId, sessionId, hacoId: id})
            .then((results) => {
                // jwt, token, hacoToken, apiKey
                creds = results.data;
                console.log('creds: ', creds);
                gotCreds = true;
                console.log("gotCreds: ",gotCreds);
                setupHACO();

            }).catch((error)=>{
                console.log("getCreds error: ", error);
                status = `Error trying to get credentials: ${error}`;
            });
    }
    async function setupHACO(){
        console.log("setupHACO");
        console.log("gotCreds: ",gotCreds);
        try {
            const client = new NexmoClient({debug:false});
            const app = await client.createSession(creds.jwt);
            conversation = await app.getConversation(hacoDetails.conversationId);
            console.log('setup conversation: ',conversation);  

            conversation.on('text', (sender, event) => {
                console.log('*** Message received', sender, event) 
            });

            // Initialize an OpenTok Session object
            session = OT.initSession(creds.apiKey, hacoDetails.sessionId);
            console.log('setup session: ',session);
            // session.connect(token);

            setupCompleted = true;
            console.log("setupCompleted: ",setupCompleted);

        }
        catch (error){
            console.error('error in setup: ', error);
            status = `Error in setup: ${error}`;
        }
    };


    function handleUserLogout(){
        console.log('user logged out');
        dispatch('closeHaco', {
            data: "haco leave clicked"
        });
    }

    function updateMemberStatus(memberId, action){
        console.log("id action", memberId, action);
        $db.collection("hacos").doc(id).set({
            members:{[memberId]:{ status: action }}
        },{ merge: true }).then(() => {
            console.log("Member successfully updated!");
        }).catch((error) => {
            console.error("Error updating member: ", error);
        });
    }

    function copyURL(){
        navigator.clipboard.writeText(hacoURL).then(function() {
        /* clipboard successfully set */
        copy = "copied";
        setTimeout( () => {copy = "copy"}, 1000);
        }, function() {
        /* clipboard write failed */
        });

    }


</script>

<section>
    {#if hacoActive}
        <div id="left">
            <dwane-timer bind:this={timer} timer-deadline={$next_session} countdown-start="3600000" timer-orientation="vertical"></dwane-timer>
            {#if memberStatus === "admin"}
                <br/><input bind:value={hacoURL} disabled />
                <br/><button on:click={copyURL}>{copy} URL</button>
                <br/><br/><a href="https://twitter.com/intent/tweet?text=%23HACO (Help A Coder/Creator Out!) %0D%0A{hacoDetails.title} %0D%0AJoin me at {hacoURL} (a @lifelongdev site) %23UntilItWorks %23{$hashtag}" target="_blank">click to share on Twitter</a>
                <br/><br/>admin controls
                <fieldset>
                    <legend>pending</legend>
                    {#each membersPending as member}
                        <br/><a href="https://{member.provider}/{member.username}" target="_blank">{member.username}</a>
                        <br/><br/><button on:click={() => {updateMemberStatus(member.id,"approved")} }>approve</button><button on:click={() => {updateMemberStatus(member.id,"denied")} }>deny</button>
                    {/each}    
                </fieldset>
                <fieldset>
                    <legend>approved</legend>
                    {#each membersApproved as member}
                        <br/><a href="https://{member.provider}/{member.username}" target="_blank">{member.username}</a>
                        <button on:click={() => {updateMemberStatus(member.id,"banned")} }>ban</button>
                    {/each}
                </fieldset>
            {/if}
        </div>
        {#if memberStatus}
            {#if memberStatus === "pending"}
                <div>Request sent. Waiting for admin.</div>
            {:else if memberStatus === "denied"}
                <div>Sorry, request was denied.</div>
            {:else if memberStatus === "banned"}
                <div>Looks like you've been banned</div>
            {:else if (memberStatus === "approved" || memberStatus === "admin") }
                <div id="content">
                    <!-- {hacoDetails.members[$user.uid].status} | {memberStatus} | {firstLoad} -->
                    <!-- {} -->
                    <!-- HACO section id: {id} isAdmin: {isAdmin} -->
                    <ha-co bind:this={haco} on:user-logout={handleUserLogout}></ha-co>
                    <!-- haco -->
                </div>
            {/if}
        {:else}
            {#if $user}
                {#if $user.isBanned}
                    <span></span>
                {:else}
                    <div>
                        <h2>Please DO NOT give passwords, account info or ANYTHING!</h2>
                        <button on:click={sendRequest} disabled={requestSent}>Request to join</button>
                        <br/>{status}
                    </div>
                {/if}
            {:else}
                <div>
                    Please sign in before joining a HACO.
                    <SignIn />
                </div>
            {/if}
        {/if}
    {:else}
        <h1>HACO not active</h1>
    {/if}
</section>

<style>
    section {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        max-width: 1500px;
        margin: auto;
    }

    #left {
        width: 200px;
    }

    #content {
        width: 100%;
        height: 90%;
    }

    dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        --dwane-timer-text-color: black;
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }

    fieldset {
        text-align: left;
    }

    legend {
        background-color: #000;
        color: #fff;
        padding: 3px 6px;
    }

    button {
        cursor: pointer;
    }

</style>